import { render, staticRenderFns } from "./SquareWithIcon.demo.vue?vue&type=template&id=10058bf6&"
import script from "./SquareWithIcon.demo.vue?vue&type=script&lang=js&"
export * from "./SquareWithIcon.demo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports